module.exports = __webpack_public_path__ + "img/icon-pro-1.89d7451d.png";